import types from './types';
import * as api from './api';
import { createTestCaseActions } from '../../../common/test-case/actions';

export default createTestCaseActions(types, api);
